<template>
  <v-data-table
    :headers="headers"
    :items="items"
    item-key="domain"
    hide-default-footer
    dense
  >
  </v-data-table>
</template>

<script>
import utility from "../utility/utility";
export default {
  props: {
    weightsData: Object,
  },
  data() {
    return {
      headers: [
        { text: "Domain", value: "domain" },
        {
          text: "Domestic Hot Water",
          value: "domestic_hot_water".toUpperCase(),
        },
        { text: "Cooling", value: "cooling".toUpperCase() },
        {
          text: "Monitoring and Control",
          value: "monitoring_and_control".toUpperCase(),
        },
        { text: "Lighting", value: "lighting".toUpperCase() },
        {
          text: "Electric Vehicle Charging",
          value: "electric_vehicle_charging".toUpperCase(),
        },
        { text: "Ventilation", value: "ventilation".toUpperCase() },
        { text: "Electricity", value: "electricity".toUpperCase() },
        {
          text: "Dynamic Building Envelope",
          value: "dynamic_building_envelope".toUpperCase(),
        },
        { text: "Heating", value: "heating".toUpperCase() },
      ],
      items: [],
    };
  },
  mounted() {
    if (this.weightsData) this.setItems();
  },
  methods: {
    setItems: function () {
      let domainWeights = JSON.parse(
        JSON.stringify(this.weightsData.default_domain_weights)
      );
      let impacts = Object.keys(domainWeights).map((impact) => {
        let domains = Object.keys(domainWeights[impact]);
        domains.forEach((domain) => {
          domainWeights[impact][domain] =
            domainWeights[impact][domain].toFixed(2);
        });
        return {
          domain:
            utility.convertStrToLabel(impact) +
            "(" +
            this.weightsData.default_impact_weights[impact].toFixed(2) +
            ")",
          ...domainWeights[impact],
        };
      });
      this.items = impacts;
    },
  },
  watch: {
    weightsData: function (value) {
      if (value) {
        this.setItems();
      }
    },
  },
};
</script>
